import React, { Component } from "react";
import PropTypes from "prop-types";

import { ImagePicker, DarkScreenMask, ConfirmModal } from "../../..";
import plusIcon from "../../../assets/imgs/plus.png";
import trash from "../../../assets/imgs/icon-close.svg";
import ImageTools from "../../../utils/imageTools";
import "./SponsorUpload.scss";

class SponsorUpload extends Component {
  static propTypes = {
    id: PropTypes.string,
    image: PropTypes.string,
    onRemoveLogo: PropTypes.func,
    onSave: PropTypes.func,
    title: PropTypes.string
  }

  static defaultProps = {
    id: "default-id",
    image: "",
    onRemoveLogo: ()=> {},
    onSave: ()=> {},
    title: "Upload"
  }


  state = {
    shouldDisplayCropper: false,
    pickerImage: ""
  }

  componentDidUpdate(prevProps) {
    const { image } = this.props;
    if (image && !this.state.image) {
      this.setState({
        image
      })
    }
    
    if (image !== prevProps.image) {
      this.setState({
        image
      });
    }
  }

  handleImageChange = async event => {
    if (!event || !event.target.files.length) {
      return;
    }

    const eventCopy = { ...event };
    const reader = new FileReader();

    reader.onloadend = onLoadEvent => {
      this.setState(prevState => ({
        ...prevState,
        shouldDisplayCropper: true,
        pickerImage: onLoadEvent.target.result
      }));
    };
    ImageTools.resize(eventCopy.target.files[0], compressed => {
      reader.readAsDataURL(compressed);
    });
  };

  handleCancelImageCropper = ()=> {
    this.setState({
      shouldDisplayCropper: false
    });
  }

  handleSaveImage = image => {
    const { onSave } = this.props;
    this.setState({
      shouldDisplayCropper: false,
      image
    });

    onSave(image);
  }

  handleRemoveLogo = ()=> {
    const { onRemoveLogo } = this.props;
    this.setState({
      image: "",
      shouldDisplayConfirmModal: false
    });
    onRemoveLogo();
  }

  toggleConfirmModal = ()=> {
    this.setState(prevState => ({
      shouldDisplayConfirmModal: !prevState.shouldDisplayConfirmModal
    }));
  };




  render() {
    const { title, id, aspectRatio, cropperStyle, className } = this.props;
    const { shouldDisplayCropper, pickerImage, image, shouldDisplayConfirmModal } = this.state;
    return (
      <div className={`sponsor-upload ${className}`}>
        <input
          type="file"
          accept="image/x-png,image/gif,image/jpeg"
          id={id}
          style={{ display: "none" }}
          value=""
          onChange={this.handleImageChange}
        />
        <label className="sponsor-upload__label" htmlFor={id}>
          {image ? 
            <img className="sponsor-upload__label__image" src={image} alt="sponsor-image" /> :
            <div className="sponsor-upload__label__placeholder">
              <img
                className="sponsor-upload__label__placeholder__icon" 
                src={plusIcon} alt="plus-icon" 
              />
              <span className="sponsor-upload__label__placeholder__title">{title}</span>
            </div>
          }
        </label>
        {image &&
          <button className="sponsor-upload__trash" onClick={this.toggleConfirmModal}>
            <img src={trash} alt="trash-icon"/>
          </button>
        }
        <DarkScreenMask isVisible={shouldDisplayCropper}>
          <ImagePicker 
            img={pickerImage}
            aspectRatio={aspectRatio}
            cropperStyle={cropperStyle}
            isRound={false}
            handleCancel={this.handleCancelImageCropper}
            handleSave={this.handleSaveImage}
          />
        </DarkScreenMask>
        <DarkScreenMask isVisible={shouldDisplayConfirmModal}>
          <ConfirmModal 
            onApprove={this.handleRemoveLogo}
            onDismiss={this.toggleConfirmModal}
            title="Are you sure you want to remove sponsor?"
          />
        </DarkScreenMask>
      </div>
    )
  }  
};

export default SponsorUpload;